import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Box } from "@mui/material";

// Local imports
import { fetchSingAlongVideo } from "../api/course-service";
import LoadingIcon from "./loading/LoadingIcon";
import Error from './Error';
import { ErrorState } from "../scripts/errorHandling";
import { LoadedDataState, useLoadedData } from "../scripts/loadedData/loadedData";
import { constructCloudFrontURL } from "../scripts/utils";
import { createActivity } from "../api/activity-service";
import { activityTypes } from "@fontan/shared";


function logSingAlongActivity(type, singAlongId, name, videoElement) {
    createActivity(type, name, {
        singAlongId,
        currentTime: videoElement.currentTime,
    }).catch(console.error);
}

const SingAlong = () => {
    const { id } = useParams();

    const [ video, manageVideo ] = useLoadedData();

    useEffect(() => {
        // Ignore responses for a previous id if the id changes mid-request
        let ignore = false;
        manageVideo.setWorking();
        fetchSingAlongVideo(id).then(
            data  => { if (!ignore) data ? manageVideo.setSuccess(data) : manageVideo.setFailure(ErrorState.NO_VIDEO_DATA) },
            error => { if (!ignore) manageVideo.setFailure(ErrorState.NO_VIDEO_DATA, error) },
        );
        return () => { ignore = true; };
    }, [id])

    if (video.state === LoadedDataState.FAILURE) {
        return <Error message={ video.error?.cause?.message ?? "Error fetching video" } />
    }

    if (video.state !== LoadedDataState.SUCCESS) {
        return <LoadingIcon />
    }

    const { name, url, cc_url } = video.value;

    const urlParts = url.split('/');
    const thumbURL = `${ urlParts.slice(0, -1).join('/') }/thumb/${ urlParts.at(-1).replace('.mp4', '') }/title.jpg`;

    return (
        <div>
            <h1>Sing along: {name}</h1>
            <Box
                component="video"
                key={ id }
                src={ constructCloudFrontURL(url) }
                poster={ constructCloudFrontURL(thumbURL) }
                controls
                playsInline
                preload="metadata"
                crossOrigin="anonymous"
                onPlay={ e => logSingAlongActivity(activityTypes.USER_START_PLAYBACK, id, name, e.currentTarget) }
                // Browsers also fire `pause` when the video ends; that's logged as a completion instead
                onPause={ e => { if (!e.currentTarget.ended) logSingAlongActivity(activityTypes.USER_PAUSE_PLAYBACK, id, name, e.currentTarget) } }
                onEnded={ e => logSingAlongActivity(activityTypes.USER_COMPLETED_VIDEO, id, name, e.currentTarget) }
                sx={{
                    display: 'block',
                    width: '100%',
                    maxWidth: 1000,
                    mx: 'auto',
                    aspectRatio: '16 / 9',
                    backgroundColor: 'black',
                    borderRadius: 4,
                    mb: 4,
                }}
            >
                { cc_url && (
                    <track
                        kind="captions"
                        label="English"
                        srcLang="en"
                        src={ constructCloudFrontURL(cc_url) }
                        default
                    />
                )}
            </Box>
        </div>
    )
}

export default SingAlong;
